<div class="toaster position-fixed top-0 end-0 p-3">
  <div class="">
    <div *ngFor="let toast of currentToasts; index as i">
      <app-toast
        [type]="toast.type"
        [title]="toast.title"
        [infinite]="toast.infinite!"
        [message]="toast.message"
        (disposeEvent)="dispose(i)"
      ></app-toast>
    </div>
  </div>
</div>
